import hr from "./hr.json";
import en from "./en.json";

const resources = { en, hr };

export default resources;
